export default __webpack_public_path__ + "static/media/bg-1.5893b4fe.jpg";